import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MiddlePanelConstant } from "../../../../containers/WorkkardDetail/constants";
import {getResolutionName} from '../../../../containers/WorkkardDetail/utils';
import Icons from '../../../../icons';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { toCamelCase } from '@/common/util';

const NoteResolution = (props) => {
    const [actionMenuVisible, setActionMenuVisible] = React.useState(false);
    const activityDetail = useSelector(state => state.workkardDetail.activityDetail);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userList = useSelector(state => state.userList);
    const userView = sessionContext?.userView;

    const publishedByName = props.data.PublishedBy
        || (() => {
            const user = userList?.[props.data.PublisherId];
            return user
                ? `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim()
                : '';
        })();

    const changedByName = props.data.Name
        || (() => {
            const user = userList?.[props.data.CreatedBy];
            return user
                ? `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim()
                : '';
        })();



    const {data} = props;
    return(
        <React.Fragment>
            <div className="rowSpaceBetween" onMouseLeave={() => { setActionMenuVisible(false) }}>
                <span className="userInfo alignMiddle flexWrap">
                
                <p className="resolutionBlock mr">{MiddlePanelConstant.Note.ChangeResolutionText}
                    <span className={`status ml ${getResolutionName((data.FromResolution || '').toLowerCase(),true)}`}>{toCamelCase(data.FromResolution)}</span>{' '}to{' '}
                    <span className={`status ${getResolutionName((data.ToResolution || '').toLowerCase(),true)}`}>{toCamelCase(data.ToResolution)}</span>
                </p> 
                <label className="mrNone">by {changedByName}</label>
                <span className="dateTime"><label className="mrNone">{(data.PrettyCreatedDate || '').split('at')[1] || ''}</label></span>
                </span>
            </div>
             {
                 ((data.InternalToPublic && (activityDetail.ownerOrgId == userView?.orgId ||
                    activityDetail.assigneeOrgId == userView?.orgId))
                    && data.OrganizationId == userView?.orgId ||
                    (data.InternalToPublic && (sessionContext.accessToOrgIds || []).includes(data.OrganizationId) && !data.iswkshared)) &&  
                <div className="publishNotesAdded alignMiddle">
                    <Icons name="public" className="icon mr" />    
                    <label >{MiddlePanelConstant.Note.PublishedByText} 
                        <span className="mr black">{publishedByName}</span>from Internal to Public on {data.PublishedDateString}
                    </label>
                </div> 
             }
            {
            <>
                <div className="clr"></div>
                {(data.FromAssignee || data.FromAssigneeOrg || data.ToAssignee || data.ToAssigneeOrg ) && <div className="change_assignee">
                    {(data.FromAssignee || data.FromAssigneeOrg) && MiddlePanelConstant.Note.ReassignedFrom}
                    {(data.FromAssignee && data.FromAssignee !== 0) ? 
                        <div className="assignee_info">
                            <span className="tool_tip">{data.FromAssignee?.DisplayName}</span>
                        </div>
                        :
                        ((data.FromAssigneeOrg) && 
                        <div className="assignee_info">
                            <span className="tool_tip">{data.FromAssigneeOrg.OrganizationName}</span>
                        </div>)
                    }
                    {(data.FromAssignee || data.FromAssigneeOrg) && MiddlePanelConstant.Note.To}
                    {(data.ToAssignee && data.ToAssignee !== 0) ?
                        <div className="assignee_info">
                            <span className="tool_tip">{data.ToAssignee?.DisplayName}</span>
                        </div>
                        :
                        ((data.ToAssigneeOrg) && 
                        <div className="assignee_info">
                            <span className="tool_tip">{data.ToAssigneeOrg.OrganizationName}</span>
                        </div>)
                    }
                </div> }                       
            </>
            }
        </React.Fragment>
    );
};

export default NoteResolution;